// extracted by mini-css-extract-plugin
module.exports = {"sectionLayout":"SectionLayout_sectionLayout__LQenb"};